import { createContext } from 'react';

import type { DragState } from '@use-gesture/react';

import type { GridSettings } from './grid-types';

export interface GridItemContextType {
  top: number;
  disableDrag: boolean;
  endTraverse: () => void;
  mountWithTraverseTarget?: [number, number];
  left: number;
  i: number;
  onMove: (state: DragState, x: number, y: number) => void;
  onEnd: (state: DragState, x: number, y: number) => void;
  onStart: () => void;
  grid: GridSettings;
  dragging: boolean;
}

export const GridItemContext = createContext<GridItemContextType | null>(null);
